import { ConsumerPostSubmissionDeclinedView } from './components/consumer-post-submission-declined-view/consumer-post-submission-declined-view.component'

export const ConsumerPostSubmissionDeclined = () => {
  return <ConsumerPostSubmissionDeclinedView />
}
